import { render } from "./single-card.vue?vue&type=template&id=40fca126"
import script from "./single-card.vue?vue&type=script&setup=true&lang=js"
export * from "./single-card.vue?vue&type=script&setup=true&lang=js"

import "./single-card.vue?vue&type=style&index=0&id=40fca126&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/single-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40fca126"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40fca126', __exports__)) {
    api.reload('40fca126', __exports__)
  }
  
  module.hot.accept("./single-card.vue?vue&type=template&id=40fca126", () => {
    api.rerender('40fca126', render)
  })

}


export default __exports__